export default __webpack_public_path__ + "static/media/login-YT.9e78fcf0.svg";